import { css } from '@emotion/css';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import type {GridLayout} from 'Shared/model/Components';
import { Checkbox, Integer } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { CopyItemPopup } from 'Shared/forms/CopyItemPopup';
import { copyComponentItem } from 'Shared/backend/widgets/copyComponentItem';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { initImage, fieldsToKeep } from 'Shared/backend/widgets/CreationUtils';
import { theme } from 'Shared/ThemeProvider';


export function initGrid(old:any)
{
	const {items} = fieldsToKeep(old);
	return {layout:'grid',cellHeight:{height:'500px'},align:'stretch',items};
}
import { verticalStyle } from 'Shared/backend/Theme';
import { ComponentTitle } from 'Shared/backend/widgets/ComponentTitle';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { SeparatedComponentAndSelector } from 'Shared/backend/widgets/SeparatedComponentAndSelector';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { Show, createSignal } from 'solid-js';
import { repeaterBarStyle } from 'Shared/backend/widgets/SectionList';


//XXX Maybe in time allow different column widths. NB can nest in columns and styles for some control

const buttonRowStyle = css({
	display: 'flex',
	gap: '0.5em',
});

export function Grid(P:GridLayout)
{
	const addTileStyle = css(theme().button,{
		alignSelf: 'flex-start'
	});

	const tileStyle = css({
		borderLeft: 'solid 5px #f4f4f4',
		paddingLeft: '1em',
		display: 'flex',
		flexDirection : 'column',
		gap: '0.8em'
	});

	const sw = useStore();
	const lo = useLayout();
	let itemsNode!: HTMLElement;

	const [showCopy, setShowCopy] = createSignal(false);

	const options = optionList(['image','text','vertical','styles'],['popup']);


//TODO probably better to put gaps in here than in theme I suspect

	return (
		<div class={css(verticalStyle())}>
			<Show when={lo.layout()}>
				<LabelOnLeftWrap label='Number of columns'>
					<Integer field='itemsPerRow' initialValue={2} />
				</LabelOnLeftWrap>

				<StoreProvider {...sw} location={[...sw.location,'cellHeight']}>
					<VerticalConstraint {...P.cellHeight} label='Cell height' options={['child','ratio','height']} />
				</StoreProvider>

				<LabelOnLeftWrap label='Use single column on mobile'>
					<Checkbox field='fold' initialValue={true} />
				</LabelOnLeftWrap>
			</Show>

			<StoreRepeater ref={itemsNode} permission='edit' field='items'
				renderTitle={i => <ComponentTitle {...i}/>}
				barStyle={repeaterBarStyle}
				hideDelete={!lo.layout()}
			>
				{(_item,index) => (
					<StoreProvider {...sw} location={[...sw.location,'items',index]}>
						<div class={tileStyle}>
							<SeparatedComponentAndSelector {...P.items[index]} layout={P.items[index].layout} options={options} />
						</div>
					</StoreProvider>
				)}
			</StoreRepeater>

			<Show when={lo.layout()}>
				<div class={buttonRowStyle}>
					<button class={addTileStyle}
						onClick={() => addItemAndOpen(sw,'items',itemsNode,initImage())}
					>
						<i class='fas fa-plus'/> Add cell
					</button>
					<Show when={P.items?.length > 0}>
						<button class={addTileStyle} onClick={() => setShowCopy(true)}>
							Copy cell
						</button>
					</Show>
				</div>
			</Show>

			<Show when={showCopy()}>
				<CopyItemPopup
					title='Copy cell'
					selectLabel='Cell to copy'
					count={P.items.length}
					close={() => setShowCopy(false)}
					onCopy={i => copyComponentItem(sw, 'items', P.items, i).then(() => setShowCopy(false))}
				/>
			</Show>
		</div>
	);
}
